module.exports = __webpack_public_path__ + "static/img/scene06.eaac3a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/scene06.png
// module id = XnIc
// module chunks = 1